/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Fact_PriceInputs */

const cs_ebr_fact_price = /** @type {(inputs: Ebr_Fact_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena`)
};

const en_ebr_fact_price = /** @type {(inputs: Ebr_Fact_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Ebr_Fact_PriceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_fact_price = /** @type {((inputs?: Ebr_Fact_PriceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Fact_PriceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_fact_price(inputs)
	return cs_ebr_fact_price(inputs)
});